import { z } from 'zod';

/**
 * Zod schema for dependency result.
 *
 * Represents a single predecessor → successor relation.
 */
export const dependencyResultSchema = z.object({
  id: z.number().int().positive(),
  predecessorItemId: z.number().int().positive(),
  successorItemId: z.number().int().positive(),
});

export type DependencyResultDTO = z.infer<typeof dependencyResultSchema>;
